export const zIndexes = {
    login: 2,
    menu: 3,
    header: 4,
    overlay: 10,
    loader: 1,
    menuOverlay: 5,
    aboveMenu: 6
}